var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaletteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.39 32.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffeaee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.39,16.29c.37-23.88-40.28-20.39-26.56,3.24,5.96,9.11,8.91-1.33,15.12,2.45,2.01,3.4-4.57,5.22-2.35,8.82.96,2.4,3.81,1.16,5.71.79,5.61-2.15,7.63-9.98,8.07-15.3Zm-23.17-2.57c-2.49.86-4.19-1.8-3.63-4.03.29-1.17,1.31-2.04,2.55-1.89.89.11,1.63.74,2.1,1.46,1,1.53.93,3.78-1.03,4.47Zm5.26-5.43c-4.31-.6-2.21-6.92,1.77-5.41,2.29,1.35,1.03,5.62-1.77,5.41Zm8.85,1.95c-.26,0-.51-.02-.76-.06-.5-.09-.92-.55-1.18-.97-.43-.69-.59-1.59-.32-2.37.34-.98,1.23-1.71,2.29-1.52.95.16,1.79.87,2.32,1.65.46.68.8,1.68.26,2.41-.35.48-.94.69-1.5.77-.36.05-.73.09-1.1.09Zm5.7,5.46c-.43.93-1.75,1.29-2.68,1.04-.45-.12-.86-.39-1.09-.8-.35-.63-.2-1.62,0-2.28.13-.43.38-.83.78-1.06.75-.42,1.72-.17,2.36.34.85.68,1.09,1.78.63,2.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaletteIcon);
export default __webpack_public_path__ + "static/media/PaletteIcon.ee5ef26df0959d3ca4bd6015c9d3fc58.svg";
export { ForwardRef as ReactComponent };